<template>
  <div class="wrapper">
    <header class="main-header">
      <alt-logo></alt-logo>
      <alt-navbar></alt-navbar>
    </header>
    <aside class="main-sidebar">
      <alt-sidebar></alt-sidebar>
    </aside>
    <div class="content-wrapper">
      <alt-content-header></alt-content-header>
      <section class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="box">
              <div class="box-body">
                <router-view/>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
    <div class="control-sidebar-bg"></div>
  </div>
</template>

<script>
import jquery from 'jquery'
import AltLogo from './AltLogo'
import AltNavbar from './AltNavbar'
import AltSidebar from './AltSidebar'
import AltContentHeader from './AltContentHeader'
export default {
  name: 'layout',
  components: {
    AltContentHeader,
    AltLogo,
    AltNavbar,
    AltSidebar
  },
  data () {
    return {
    }
  },
  mounted () {
    jquery('body').resize()
    // 二级菜单点击无反应问题
    jquery('[data-widget="tree"]').tree({
      animationSpeed: 500,
      accordion: true,
      followLink: false,
      trigger: '.treeview a'
    })
    // 收缩左侧菜单动画不显示问题
    jquery('[data-toggle="push-menu"]').pushMenu({
      collapseScreenSize: 767,
      expandOnHover: false,
      expandTransitionDelay: 200
    })
  },
  created () {
    document.body.setAttribute('class', 'hold-transition skin-blue sidebar-mini')
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Layout/index.vue